module.exports = __webpack_public_path__ + "static/img/PEA.aa69ee5c.png";